import { createReducer } from '@reduxjs/toolkit'
import { forEach, merge } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'
import { exists } from '@utils/functions.js'

export const initialState = {
  currentUserId: null,
  entities: {},
}

export const user = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_USERS, (state, action) => receiveUsers(state, action))
    .addCase(ActionTypes.RECEIVE_CURRENT_USER, (state, action) => receiveCurrentUser(state, action))
    .addCase(ActionTypes.REMOVE_USERS, (state, action) => removeUsers(state, action))
    .addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
})

export default user

function receiveUsers(state, action) {
  const { payload: users } = action
  if (exists(users)) {
    forEach(users, user => {
      const idString = user.id.toString()
      const existing = state.entities[idString] || {}
      state.entities[idString] = merge(existing, user)
    })
  }
  return state
}

function receiveCurrentUser(state, action) {
  const { payload: user } = action
  if (exists(user)) {
    const idString = user.id.toString()
    state.currentUserId = user.id
    state.entities[idString] = merge(state.entities[idString] || {}, user)
  }
  return state
}

function removeUsers(state, action) {
  const { payload: userIds } = action
  forEach(userIds, userId => delete state.entities[userId])
  return state
}

function receiveEntities(state, action) {
  const { payload } = action
  let idString
  if (payload.hasOwnProperty('current_user')) {
    const { current_user: currentUser } = payload
    if (currentUser) {
      idString = currentUser.id.toString()
      state.currentUserId = currentUser.id
      state.entities[idString] = merge(state.entities[idString] || {}, currentUser)
    }
  }
  if (payload.hasOwnProperty('user')) {
    const { user } = payload
    idString = user.id.toString()
    state.entities[idString] = merge(state.entities[idString] || {}, user)
  }
  if (payload.hasOwnProperty('users')) {
    const { users } = payload
    forEach(users, user => {
      idString = user.id.toString()
      state.entities[idString] = merge(state.entities[idString] || {}, user)
    })
  }
  return state
}
